import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EMAIL_PATTERN } from '@cakeiteasy/web-utils';
import { AUTH_FORMS } from '../../constants';

@Component({
  standalone: false,
  selector: 'lost-password-form',
  templateUrl: './lost-password-form.component.html'
})
export class LostPasswordFormComponent {
  @Input() error: string;
  @Input() requestSuccess: boolean = false;
  @Output() onSubmit = new EventEmitter<string>();

  @Output() onBack = new EventEmitter<string>();
  @Output() onCreateNewAccount = new EventEmitter<string>();

  /**Deprecated*/
  @Output() onFormChange = new EventEmitter<string>();

  public AUTH_FORMS = AUTH_FORMS;
  public EMAIL_PATTERN = EMAIL_PATTERN;
  public email: string;
}
